import { useMemo, useState } from "react";
import { Box, Modal } from "@mui/material";
import { ReactComponent as Close } from "../../assets/images/close.svg";
import { Button, Typography } from "../../ui";
import STATIC_INTERESTS_DATA_BY_MONTH from "./data/staticInterestsData";
import DYNAMIC_SEGMENTS from "./data/dynamicSegments";
import DYNAMIC_SEGMENTS_JULY from "./data/dynamicSegmentsJuly";
import DYNAMIC_SEGMENTS_AUGUST from "./data/dynamicSegmentsAugust";
import DYNAMIC_SEGMENTS_SEPTEMBER from "./data/dynamicSegmentsSeptember";
import "./InterestsModal.scss";

const MONTHS = [
  { value: 1, label: "Январь" },
  { value: 2, label: "Февраль" },
  { value: 3, label: "Март" },
  { value: 4, label: "Апрель" },
  { value: 5, label: "Май" },
  { value: 6, label: "Июнь" },
  { value: 7, label: "Июль" },
  { value: 8, label: "Август" },
  { value: 9, label: "Сентябрь" },
  { value: 10, label: "Октябрь" },
  { value: 11, label: "Ноябрь" },
  { value: 12, label: "Декабрь" },
];

const DEFAULT_YEAR = 2026;
const STATIC_INTERESTS_MONTHS = [5, 6, 7, 8, 9];
const DYNAMIC_SEGMENTS_BY_MONTH = {
  5: DYNAMIC_SEGMENTS,
  6: DYNAMIC_SEGMENTS,
  7: DYNAMIC_SEGMENTS_JULY,
  8: DYNAMIC_SEGMENTS_AUGUST,
  9: DYNAMIC_SEGMENTS_SEPTEMBER,
};

function InterestsModal({ open, onClose }) {
  const [selectedMonth, setSelectedMonth] = useState(STATIC_INTERESTS_MONTHS[0]);
  const [selectedYear, setSelectedYear] = useState(DEFAULT_YEAR);

  const selectedMonthLabel = useMemo(
    () => MONTHS.find((month) => month.value === selectedMonth)?.label || "",
    [selectedMonth]
  );

  const staticInterestsData = useMemo(
    () => STATIC_INTERESTS_DATA_BY_MONTH[selectedMonth] || [],
    [selectedMonth]
  );

  const dynamicSegments = useMemo(
    () => DYNAMIC_SEGMENTS_BY_MONTH[selectedMonth] || [],
    [selectedMonth]
  );

  const showStaticInterests = STATIC_INTERESTS_MONTHS.includes(selectedMonth);
  const showDynamicInterests = Boolean(DYNAMIC_SEGMENTS_BY_MONTH[selectedMonth]);

  return (
    <Modal open={open} onClose={onClose}>
      <Box className="InterestsModal">
        <Close onClick={onClose} className="InterestsModal__close" />
        <Typography variant="h2" color="dark-gray">
          Интересы
        </Typography>

        <div className="InterestsModal__filters">
          <div className="InterestsModal__filter">
            <span className="InterestsModal__filter-label">Месяц</span>
            <div className="InterestsModal__select-wrap">
              <select
                id="interests-month"
                className="InterestsModal__select"
                value={selectedMonth}
                onChange={(event) => setSelectedMonth(Number(event.target.value))}
              >
                {MONTHS.map((month) => (
                  <option key={month.value} value={month.value}>
                    {month.label}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="InterestsModal__filter">
            <span className="InterestsModal__filter-label">Год</span>
            <div className="InterestsModal__select-wrap">
              <select
                id="interests-year"
                className="InterestsModal__select"
                value={selectedYear}
                onChange={(event) => setSelectedYear(Number(event.target.value))}
              >
                <option value={DEFAULT_YEAR}>{DEFAULT_YEAR}</option>
              </select>
            </div>
          </div>
        </div>

        <div className="InterestsModal__section">
          <Typography variant="h2" color="dark-gray">
            Статические интересы
          </Typography>
          <p className="InterestsModal__subtitle">
            {selectedMonthLabel} {selectedYear}
          </p>
          {showStaticInterests ? (
            <div className="InterestsModal__table-wrap InterestsModal__table-wrap--static">
              <table className="InterestsModal__table InterestsModal__table--static">
                <thead>
                  <tr>
                    <th>Сегмент</th>
                    <th>Охват</th>
                    <th>Переходы</th>
                    <th>Affinity index</th>
                    <th>Количество конверсий</th>
                  </tr>
                </thead>
                <tbody>
                  {staticInterestsData.map((row) => (
                    <tr key={row.segment}>
                      <td>{row.segment}</td>
                      <td>{row.reach}</td>
                      <td>{row.transitions}</td>
                      <td>{row.affinityIndex}</td>
                      <td>{row.conversions}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <p className="InterestsModal__empty">Данные за выбранный период не найдены</p>
          )}
        </div>

        <div className="InterestsModal__section">
          <Typography variant="h2" color="dark-gray">
            Динамические интересы
          </Typography>
          <p className="InterestsModal__subtitle">
            {selectedMonthLabel} {selectedYear}
          </p>
          <div className="InterestsModal__description">
            <p>
              Динамические сегменты формируются автоматически моделями машинного обучения на основе поведения
              пользователей для более точного таргетинга.
            </p>
          </div>
          {showDynamicInterests ? (
            <div className="InterestsModal__table-wrap InterestsModal__table-wrap--dynamic">
              <table className="InterestsModal__table InterestsModal__table--dynamic">
                <thead>
                  <tr>
                    <th>Сегмент</th>
                  </tr>
                </thead>
                <tbody>
                  {dynamicSegments.map((segment) => (
                    <tr key={segment}>
                      <td>{segment}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <p className="InterestsModal__empty">Данные за выбранный период не найдены</p>
          )}
        </div>

        <div className="InterestsModal__footer">
          <Button variant="primary" onClick={onClose}>
            Закрыть
          </Button>
        </div>
      </Box>
    </Modal>
  );
}

export default InterestsModal;
